import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function ProfileTab() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const user = useSelector((state) => state.auth.user);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);

    if (index === 0) {
      if (user.roles.contains("admin")) {
        navigate(`/admin-profile/${user.profile_id}`);
      } else if (user.roles.contains("super_admin")) {
        navigate(`/super-admin-profile/${user.profile_id}`);
      } else if (user.roles.contains("distributor")) {
        navigate(`/distributor-profile/${user.profile_id}`);
      }else if (user.roles.contains("machine_admin")) {
        navigate(`/machine-admin-profile/${user.profile_id}`);
      }else if (user.roles.contains("filling_person")) {
        navigate(`/filling-person-profile/${user.profile_id}`);
      }
    }
  };
  return (
    <List
      component="nav"
      sx={{
        p: 0,
        "& .MuiListItemIcon-root": {
          minWidth: 32,
          color: theme.palette.grey[500],
        },
      }}
    >
      <ListItemButton
        selected={selectedIndex === 0}
        onClick={(event) => handleListItemClick(event, 0)}
      >
        <ListItemIcon>
          <AiOutlineEdit />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton>
    </List>
  );
}

export default ProfileTab;
